import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Missions de conseil auprès des Ressources Humaines pour maintenir les seniors dans l'emploi au sein de l'entreprise en tenant compte de la législation qui évolue dans ce domaine. </h3>,
        "core": [
            {
                "subtitle": <span className='font-bold'> Passage à "temps partiel fin de carrière" :</span>,
                "text": <span> un accord d'entreprise peut donner la possibilité de proposer une rémunération supérieure au temps de travail ou de prendre en charge les cotisations retraite calculées sur une base temps plein.</span>,
            },
            {
                "subtitle": <span className='font-bold'> Retraite progressive : </span>,
                "text": <span>dispositif réservé aux actifs deux ans avant l'âge légal de départ à la retraite. La réduction du temps de travail doit être comprise entre 40% et 80% du temps complet. Ce régime permet de recevoir une partie de sa retraite.</span>,
            },
            {
                "subtitle": <span className='font-bold'> Mécénat de compétences : </span>,
                "text": <span>les collaborateurs seniors peuvent partager leurs compétences au sein d'associations ou fondations, sur leur temps de travail. Cette démarche est possible jusqu'à 3 ans avant le départ en retraite à taux plein.</span>
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Missions auprès des entreprises pour un accompagnement personnalisé de leurs salariés de plus de 55 ans : </h3>,
        "core": [
            {
                "subtitle": <span className='font-bold'> Enjeux et objectifs dans ces contextes :</span>,
                "text": <span> Souhait de l'entreprise d'accompagner ses salariés dans une démarche active et positive. </span>,
            },
            {
                "subtitle": "",
                "text": <span>Meilleure visibilité du niveau des retraites et aide dans la <strong>transition emploi-retraite,</strong>  ou dans la mise en place de dispositifs comme la <strong>retraite progressive, mécénat de compétences.</strong></span>,
            },
            {
                "subtitle": "",
                "text": <span>Lors de réorganisations ou de restructurations, nous avons un rôle de "facilitateur", permettant de rassurer individuellement les salariés et de travailler également avec toutes les Organisations Syndicales, avec une stricte confidentialité.</span>
            },
            {
                "subtitle": "",
                "text": <span>Conseils au regard de la reconstitution de carrière et l'optimisation des droits (exemple rachat de trimestres).</span>
            },
            {
                "subtitle": <span className='font-bold'> Préparation en amont :</span>,
                "text": <span>Rendez-vous avec les Ressources Humaines pour définir ensemble les objectifs et les modalités des accompagnements individuels et personnalisés.</span>
            },
            {
                "subtitle": "",
                "text": <span>Echanges avec le salarié afin d'obtenir tous les relevés de carrière de base et complémentaire.</span>
            },
            {
                "subtitle": <span className='font-bold'> Echanges directs avec le salarié, tout au long de la procédure: Au début de l'étude : </span>,
                "text": <span>analyse des relevés de carrière, définition des optimisations éventuelles, échanges sur les besoins du salarié en fonction de sa situation personnelle et professionnelle.</span>
            },
            {
                "subtitle": <span className='font-bold'> A la fin de l'étude :</span>,
                "text": <span>analyse des résultats chiffrés, commentaires et réflexions sur d'éventuelles nouvelles hypothèses au regard des résultats ou nouvelles questions.</span>
            },
        ]
    },
]

export default function Optimisations() {
   

    return (
        <>
            <Title classNames="bg-optimisation bg-cover lg:bg-right bg-left" title="Des solutions complètes d'optimisation" />

            <Subtitle subtitle="Valoriser l'expérience et l'expertise" paragraph="Accompagner les Ressources Humaines dans la gestion de carrière des seniors. Nous suivons la législation qui évolue dans ce domaine pour donner des pistes de réflexion pour favoriser l'employabilité des seniors au sein des entreprises." />      

            <Core navigation={navigation} context={context} />           

            <Footer />

            <ScrollRestoration />
        </>
    )
}